import { Observable } from "rxjs/Observable";
import { ReservationService } from "./../services/reservation-service/reservation.service";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ProjectsService } from "./../services/projects/projects.service";
import { Component, OnInit } from "@angular/core";
import { environment } from "./../../environments/environment";
import { HttpClient } from "@angular/common/http";
import swal from "sweetalert2";
import { SettingService } from "../services/settings-service/setting.service";

@Component({
  selector: "app-price-control",
  templateUrl: "./price-control.component.html",
  styleUrls: ["./price-control.component.css"],
})
export class PriceControlComponent implements OnInit {
  price_control_form: FormGroup;
  projects: any;
  arrSearch: any;
  dataFromSearch: any;
  chosen_unit: any;
  types: any;
  buildings: any[];
  designTypes: any = [];
  finishTypes: any = [
    {
      id: 1,
      name: "Finished",
    },
    {
      id: 2,
      name: "Core and Shell",
    },
    {
      id: 3,
      name: "Core and Shell & Finished",
    },
  ];
  floors: any = [
    {
      value: 0,
    },
    {
      value: 1,
    },
    {
      value: 2,
    },
    {
      value: 3,
    },
    {
      value: 4,
    },
    {
      value: 5,
    },
    {
      value: 6,
    },
    {
      value: 7,
    },
  ];

  constructor(
    private projectService: ProjectsService,
    private settingService: SettingService,
    private slimLoadingBarService: SlimLoadingBarService,
    private errorHandlerService: ErrorHandlerService,
    private fb: FormBuilder,
    private reservationService: ReservationService,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.getProjects();
    this.getUnitTypes();
    this.getFinishTypes();
  }

  getFinishTypes() {
    this.settingService.getFinishingTypes().subscribe(
      (data) => {
        this.finishTypes = data;
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
      }
    )
  }

  getBuildings() {
    this.projectService
      .getBuildings(this.price_control_form.get("project_id").value)
      .subscribe(
        (data: any) => {
          this.buildings = data;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  getdesignTypes() {
    this.slimLoadingBarService.start();
    this.price_control_form.get("design_type").setValue("");
    this.designTypes = [];

    this.projectService
      .getDesignTypes(this.price_control_form.get("project_id").value)
      .subscribe(
        (data) => {
          this.designTypes = data;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  createForm() {
    this.price_control_form = this.fb.group({
      project_id: [null, Validators.required],
      unit_type_id: [null],
      design_type: [null],
      floor_number: [null],
      building_num: [null],
      finishing_type: [null],
      price_type: ["Percentage", Validators.required],
      price_value: [null, Validators.required],
      comment: [null],
    });
    this.price_control_form.get("project_id").valueChanges.subscribe((val) => {
      console.log(val);
      if (val != "All") {
        this.price_control_form.addControl("unit_id", new FormControl(""));
      }
    });
  }

  observableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let project_id: any = this.price_control_form.get("project_id").value;
    let data = {
      unit_serial: keyword,
    };
    if (keyword) {
      return this.http
        .post(`${baseUrl}units/${project_id}/search`, JSON.stringify(data))
        .map((res: any) => {
          console.log(res.length);
          if (res.length == 0) {
            let arr = [];
            return arr;
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res;
            res.forEach((e) => {
              this.arrSearch.push(e.serial);
            });
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  getProjects() {
    this.reservationService.getProjects({ is_select_form: true }).subscribe(
      (res: any) => {
        this.projects = res;
        this.createForm();
      },
      (err) => console.log(err)
    );
  }

  selectUnit(unit_serial) {
    console.log(unit_serial);
    this.dataFromSearch.forEach((e) => {
      if (e.serial == unit_serial) {
        this.price_control_form.get("unit_id").patchValue(e.id);
      }
    });
    console.log(this.price_control_form.get("unit_id").value);
  }

  getUnitTypes() {
    this.slimLoadingBarService.start();
    this.projectService.getUnitTypes().subscribe(
      (data) => {
        this.types = data;
        console.log(this.types);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  submit() {
    let payload = this.price_control_form.value;
    payload.project_id = +payload.project_id;
    console.log(payload);
    this.slimLoadingBarService.start();
    this.projectService.requestUnitPriceChange(payload).subscribe(
      (res: any) => {
        this.createForm();
        swal(res, "", "success");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/price-control/price-control.component.ts